export const getTerrainEmptyMessageKey = (integrated) => {
  if (integrated?.terrainReason === 'mapbox_access_token_missing' ||
      integrated?.terrainReason === 'terrain_credentials_rejected') return 'terrain_source_not_configured'
  if (integrated?.terrainStatus === 'source_unavailable') return 'terrain_source_unavailable'
  if (!integrated?.terrainStatus || integrated.terrainStatus === 'not_requested') return 'terrain_not_calculated'
  return 'no_terrain_data'
}
